/** Variable / formula keys on fillable blocks. */
export const DOC_BLOCK_KEY_RE = /^[A-Za-z][A-Za-z0-9_]{0,63}$/;

/** Blocks allowed inside two_column left/right stacks (no nested columns or page breaks). */
export const DOC_NESTED_BLOCK_TYPES = [
  "heading",
  "paragraph",
  "rich_text",
  "text_field",
  "freeform_field",
  "number_field",
  "formula_field",
  "checkbox",
  "signature_line",
  "table",
  "image",
  "divider",
] as const;

export type DocNestedBlockType = (typeof DOC_NESTED_BLOCK_TYPES)[number];

/** Reserved for future component library — parsed but not editable in V1. */
export const DOC_RESERVED_BLOCK_TYPES = ["component_ref"] as const;

export type DocReservedBlockType = (typeof DOC_RESERVED_BLOCK_TYPES)[number];

export function isDocReservedBlockType(type: string): type is DocReservedBlockType {
  return (DOC_RESERVED_BLOCK_TYPES as readonly string[]).includes(type);
}

export function isDocNestedBlockType(type: string): type is DocNestedBlockType {
  return (DOC_NESTED_BLOCK_TYPES as readonly string[]).includes(type);
}
